export default "__VITE_ASSET__DsrvdbHd__"